import { render, staticRenderFns } from "./HospitalDetail.vue?vue&type=template&id=678647e4&scoped=true"
import script from "./HospitalDetail.vue?vue&type=script&lang=js"
export * from "./HospitalDetail.vue?vue&type=script&lang=js"
import style0 from "./HospitalDetail.vue?vue&type=style&index=0&id=678647e4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678647e4",
  null
  
)

export default component.exports